module.exports = __webpack_public_path__ + "static/media/importGreen.48f47eeb.svg";